<template>
    <a-card :bordered="false" class="header-solid h-full">
        <!-- Title -->
        <template #title>
            <a-row type="flex" justify="space-between" align="top">
                <a-col :span="20">
                    <h5 class="font-semibold m-0">Card History</h5>
                </a-col>
            </a-row>
        </template>
        <!-- Body -->
        <a-table :columns="columns" :data-source="data" rowKey="_id">
            <template slot="createAt" slot-scope="createAt">
                {{createAt.split('T')[0]}}
            </template>
        </a-table>
    </a-card>
</template>

<script>
import axios from 'axios';

export default ({
    props: {
        
    },
    components: {

    },
    data() {
        return {
            query: '',
            data: [],
            columns: [
                {
                    title: 'Date',
                    dataIndex: 'createAt',
                    scopedSlots: { customRender: 'createAt' },
                },
                {
                    title: 'Email',
                    dataIndex: 'email',
                    scopedSlots: { customRender: 'email' },
                },
                {
                    title: 'Card',
                    dataIndex: 'card',
                    scopedSlots: { customRender: 'card' },
                },
            ],
        }
    },
    //
    //
    //
    mounted() {
        
    },
    methods: {
        //
        //
        //
        setQuery(query) {
            this.query = query;
        },
        //
        //
        //
        requestData() {
            axios.get(
                process.env.VUE_APP_INVENTORY_API + '/uhclog/search?' + this.query, {
                headers: {
                    "Authorization" : 'Bearer ' + localStorage.getItem('accessToken')
                } 
            })
            .then(response => {
                this.data = response.data.data;
            })
            .catch(error => {
                this.$notification.open({
                    message: 'Notification',
                    description: error.response.data.message,
                    icon: <a-icon type="close-circle" style="color: #FF0000" />,
                });
                return;
            });
        },
    },
})
</script>

<style lang="scss">
</style>